module.exports = __webpack_public_path__ + "img/icon16.36e6592a.png";